import React from 'react';
import Brand from './Brand';

export default function Header({ user, isAdmin, onAdmin, onSignOut }) {
  return (
    <header className="site-header">
      <div className="header-inner">
        <a className="brand" href="/" aria-label="LeaveNOW home"><Brand size="sm" /></a>
        <div className="account-menu">
          {user?.photoURL ? <img src={user.photoURL} alt="" referrerPolicy="no-referrer" /> : <span className="avatar-fallback">{user?.displayName?.[0] || 'U'}</span>}
          {isAdmin && <button className="text-button" type="button" onClick={onAdmin}>Founder</button>}
          <button className="text-button" type="button" onClick={onSignOut}>Sign out</button>
        </div>
      </div>
    </header>
  );
}
